import { TimerTextStack } from './TimerTextStack';
import type { ThemeTokens } from '../../lib/timerThemes';

/** Keep label, complete value and secondary notice together in one fitted group. */
export function TimerStatCard({
  label,
  value,
  fontSize,
  labelSize,
  theme,
  valueColor,
  labelColor,
  secondary,
}: {
  label: string;
  value: string;
  fontSize: number;
  labelSize: number;
  theme: ThemeTokens;
  valueColor?: string;
  labelColor?: string;
  secondary?: string;
}) {
  const numeric = {
    fontFamily: theme.fontFamily,
    fontVariantNumeric: 'tabular-nums',
    letterSpacing: theme.letterSpacing,
  };
  return (
    <div
      className="h-full w-full min-h-0 min-w-0 flex flex-col items-center"
      style={{ padding: theme.statPadPx ?? 8, backgroundColor: theme.widgetBg }}
    >
      <TimerTextStack
        gap={theme.statGapPx ?? 4}
        rows={[
          {
            text: label,
            size: labelSize,
            color: labelColor ?? theme.statLabelColor,
            className: 'uppercase tracking-widest',
          },
          {
            text: value,
            size: fontSize,
            color: valueColor ?? theme.statValueColor,
            style: numeric,
            className: 'font-black leading-none',
          },
          ...(secondary
            ? [{ text: secondary, size: labelSize, color: theme.statLabelColor, style: numeric }]
            : []),
        ]}
      />
    </div>
  );
}
